export const presentAggregatedFactorValue: { [key: string]: string } = {
  ibge_income_factor: 'Localização',
  constructive_pattern_factor: 'Padrão',
  area_factor: 'Área Construída',
  parking_spaces_factor: 'Vaga',
  age_factor: 'Idade Estimada',
  preservation_status_factor: 'Estado de Conservação',
  land_area_factor: 'Terreno',
};
